import { render, staticRenderFns } from "./VersionsView.vue?vue&type=template&id=6ebd8ab8&scoped=true&"
import script from "./VersionsView.vue?vue&type=script&lang=js&"
export * from "./VersionsView.vue?vue&type=script&lang=js&"
import style0 from "./VersionsView.vue?vue&type=style&index=0&id=6ebd8ab8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebd8ab8",
  null
  
)

export default component.exports